import { Alert, Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import type { File } from '~ui-components/components/atoms/file-dropzone';

export type BlankFilesListProps = { requiredFiles: string[] };
export const BlankFilesList: React.FC<BlankFilesListProps> = ({
	requiredFiles,
}) => {
	return (
		<Stack spacing={3}>
			<Typography color="text.secondary" variant="body2">
				Files required
			</Typography>
			<Divider />
			{requiredFiles.map((file, index) => (
				<React.Fragment key={index}>
					<Typography
						style={{ width: '100px' }}
						color="text.secondary"
						variant="body1"
					>
						{file}
					</Typography>
					<Divider />
				</React.Fragment>
			))}
		</Stack>
	);
};

export type FilesListWithProgressProps = {
	requiredFiles: string[];
	files: File[];
	progresses: { [fileName: string]: number };
	onFilesRemoved: () => void;
};
export const FilesListWithProgress: React.FC<FilesListWithProgressProps> = ({
	requiredFiles,
	files,
	progresses,
	onFilesRemoved,
}) => {
	return (
		<Stack spacing={3}>
			<Typography color="text.secondary" variant="body2">
				Files required
			</Typography>
			<Divider />
			{requiredFiles.map((requiredFile) => {
				const matchingGivenFile = files.find((f) =>
					f.name.includes(requiredFile)
				);

				return (
					<>
						<Stack
							key={requiredFile}
							direction="row"
							spacing={2}
							sx={{ alignItems: 'center' }}
						>
							<Typography
								style={{ width: '100px' }}
								color="text.secondary"
								variant="body1"
								textTransform="uppercase"
							>
								{requiredFile}
							</Typography>
							<Typography style={{ width: 350 }}>
								{matchingGivenFile?.name || ''}
							</Typography>
							{matchingGivenFile ? (
								<Box sx={{ width: '80%', height: '4px' }}>
									<LinearProgress
										variant="determinate"
										color="success"
										value={progresses[matchingGivenFile.name] || 0}
									/>
								</Box>
							) : (
								<Alert severity="error" sx={{ width: '80%' }}>
									File not found
								</Alert>
							)}
						</Stack>
						<Divider />
					</>
				);
			})}
			<div>
				<Button
					color="secondary"
					disabled={!files.length}
					onClick={onFilesRemoved}
					variant="outlined"
				>
					Remove
				</Button>
			</div>
		</Stack>
	);
};
